import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { redirectToLogin } from '@shared/auth/auth';
import { getImpersonatedTenantName } from '@shared/auth/impersonation';
import { isImpersonating, useTokenStore } from '@shared/auth/token.store';
import { Button } from '@shared/components/ui/Button';

export function ImpersonationBanner() {
  const { t } = useTranslation();
  const accessToken = useTokenStore((state) => state.accessToken?.token);

  if (!accessToken || !isImpersonating()) return null;

  const tenant = getImpersonatedTenantName() ?? '';

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-3 bg-amber-500 px-4 py-1.5 text-sm font-medium text-black"
    >
      <ShieldAlert className="size-4" />
      <span>{t('impersonation.banner', 'You are impersonating {{tenant}}', { tenant })}</span>
      <Button
        size="xs"
        variant="outline"
        onClick={() => {
          redirectToLogin(true);
        }}
      >
        {t('impersonation.exit', 'Exit')}
      </Button>
    </div>
  );
}
